import { render } from "./thankYouBannerComponent.vue?vue&type=template&id=d2b6c7b6"
import script from "./thankYouBannerComponent.vue?vue&type=script&lang=js"
export * from "./thankYouBannerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__